import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=df121322&scoped=true"
import script from "./OtherSettings.vue?vue&type=script&lang=js"
export * from "./OtherSettings.vue?vue&type=script&lang=js"
import style0 from "./OtherSettings.vue?vue&type=style&index=0&id=df121322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df121322",
  null
  
)

export default component.exports